
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 6.797c-.432.885-1.164 1.328-2.195 1.328-.948 0-1.69-.3-2.227-.898-.531-.605-.797-1.44-.797-2.508 0-1.709.914-3.16 2.742-4.352l.43.531c-1.11.865-1.664 2.164-1.664 3.899 0 .911.146 1.591.438 2.039.291.448.684.672 1.18.672.452 0 .801-.18 1.046-.54.25-.364.375-.874.375-1.53v-2.72h1.36v2.72c0 .666.125 1.18.375 1.539.25.354.598.53 1.046.53.521 0 .922-.231 1.204-.694.286-.464.43-1.136.43-2.016 0-.906-.134-1.656-.4-2.25-.26-.6-.687-1.149-1.28-1.649l.453-.53C9.839 1.59 10.75 3.046 10.75 4.733c0 1.084-.279 1.92-.836 2.508-.552.589-1.286.883-2.203.883-1.01 0-1.747-.443-2.211-1.328z","fill":"currentColor"}})])
          )
        }
      }
    